import React from 'react';
import './Score.css';
import Navbar from '../../Components/Navbar';


function Score() {
  return (
    <div className="score-page">
      <Navbar />
      <div className='heading-score'>
      <h1>Your score</h1>
      <p>Make sure that you have the right contract uploaded</p>
      </div>
      <div className="score-box">
        <div className="score-circle">
          <span className="score-value">7.5</span>
          <span className="score-total">/ 10</span>
        </div>
        <div className="score-details">
          <div className="score-pass">
            <span>✔</span>
            <span>06 / 13 works</span>
          </div>
          <div className="score-fail">
            <span>✖</span>
            <span>14 issues found</span>
          </div>
        </div>
           <button className="download-button" ><a href="/Login" >Download report</a></button>
      </div>
    </div>
  );
}

export default Score;